import React from "react";
import { HiMiniCheckBadge } from "react-icons/hi2";
import { motion } from "framer-motion";

function ProfilePictures({ data }) {
  return (
    <>
      <div className="flex items-center rounded-lg">
        <div className="flex-shrink-0 mr-3">
          {data !== null ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
              className="relative"
            >
              <motion.img
                src={`https://ui-avatars.com/api/?name=${data?.email}&background=EEF2FF&color=6366F1`}
                alt="User Avatar"
                className="object-cover w-12 h-12 border-2 border-green-400 rounded-full shadow-sm"
              />
              <div className="absolute w-4 h-4 bg-green-500 border-2 border-white rounded-full -bottom-1 -right-1" />
            </motion.div>
          ) : (
            <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse" />
          )}
        </div>

        <div className="flex-grow min-w-0">
          <div className="flex flex-col mb-1">
            <h3 className="mr-2 text-sm font-semibold text-gray-900 truncate dark:text-white">
              {data?.name || "Guest User"}
            </h3>
            <p className="text-xs text-gray-500 truncate dark:text-gray-300">
              {data?.email || "No email provided"}
            </p>
            <div>
              {data?.role === "supervisor" || data?.role === "administrator" ? (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-blue-700 text-xs font-medium bg-slate-200 dark:bg-slate-800 dark:text-blue-400">
                  <HiMiniCheckBadge className="mr-1" />
                  supervisor
                </span>
              ) : (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <HiMiniCheckBadge className="mr-1" />
                  officer
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfilePictures;
